/* BS: Back to top button */
(function () {
  var btn = document.querySelector('.bs-backtotop');
  if (!btn) return;

  var ticking = false;

  function prefersReducedMotion(){
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function getThreshold(){
    // Desktop vs Mobile getrennt
    var isDesktop = window.matchMedia && window.matchMedia('(min-width: 990px)').matches;
    return isDesktop ? 1900 : 1300; // px: Desktop / Mobile
  }

  function setVisible(isVisible){
    if (isVisible) {
      btn.hidden = false;
      requestAnimationFrame(function(){
        btn.classList.add('is-visible');
      });
    } else {
      btn.classList.remove('is-visible');
      window.setTimeout(function(){
        btn.hidden = true;
      }, 200);
    }
  }

  function onScroll(){
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    var shouldShow = y > getThreshold();

    var currentlyHidden = btn.hidden === true;
    if (shouldShow && currentlyHidden) setVisible(true);
    if (!shouldShow && !currentlyHidden) setVisible(false);
  }

  window.addEventListener('scroll', function(){
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function(){
      onScroll();
      ticking = false;
    });
  }, { passive: true });

  window.addEventListener('resize', function(){
    onScroll();
  }, { passive: true });

  btn.addEventListener('click', function(){
    var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
    window.scrollTo({ top: 0, left: 0, behavior: behavior });
  });

  // Initial state
  onScroll();
})();
/* ======================================================================
   BS MEGA MENU (BRANDS) – Brand Panels Switch
   - Hover/Fokus: wechselt Panel + Active State
   - Aktualisiert "Alle Produkte der Marke" Link (href)
   ====================================================================== */

(function () {
  function closestMegaMenu(el) {
    return el && el.closest ? el.closest('header-mega-menu.mega-menu--brands') : null;
  }

  function activateBrand(menuEl, index) {
    if (!menuEl) return;

    const triggers = menuEl.querySelectorAll('[data-mega-brand-trigger]');
    const panels = menuEl.querySelectorAll('[data-mega-brand-panel]');
    const allProductsLink = menuEl.querySelector('[data-mega-brand-all-products]');

    if (!triggers.length || !panels.length) return;

    // Clamp
    const safeIndex = Math.max(0, Math.min(index, triggers.length - 1));

    triggers.forEach((t, i) => {
      const isActive = i === safeIndex;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-current', isActive ? 'page' : 'false');
    });

    panels.forEach((p) => {
      const i = parseInt(p.getAttribute('data-brand-index') || '-1', 10);
      const isActive = i === safeIndex;

      p.classList.toggle('is-active', isActive);
      if (isActive) {
        p.removeAttribute('hidden');
      } else {
        p.setAttribute('hidden', '');
      }
    });

    // Update footer link to active brand
    if (allProductsLink) {
      const activeTrigger = triggers[safeIndex];
      const url = activeTrigger ? activeTrigger.getAttribute('data-brand-url') : null;
      if (url) allProductsLink.setAttribute('href', url);
    }
  }

  function initMenu(menuEl) {
    // Initial: set footer link to first brand (falls nicht schon korrekt)
    const firstTrigger = menuEl.querySelector('[data-mega-brand-trigger][data-brand-index="0"]');
    const allProductsLink = menuEl.querySelector('[data-mega-brand-all-products]');
    if (firstTrigger && allProductsLink) {
      const url = firstTrigger.getAttribute('data-brand-url');
      if (url) allProductsLink.setAttribute('href', url);
    }
    // Ensure panels state matches initial "is-active"
    activateBrand(menuEl, 0);
  }

  // Init on DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('header-mega-menu.mega-menu--brands').forEach(initMenu);
  });

  // Hover / Fokus: Event Delegation
  document.addEventListener('mouseenter', function (e) {
    const trigger = e.target && e.target.closest ? e.target.closest('[data-mega-brand-trigger]') : null;
    if (!trigger) return;

    const menuEl = closestMegaMenu(trigger);
    if (!menuEl) return;

    const idx = parseInt(trigger.getAttribute('data-brand-index') || '0', 10);
    activateBrand(menuEl, idx);
  }, true);

  document.addEventListener('focusin', function (e) {
    const trigger = e.target && e.target.closest ? e.target.closest('[data-mega-brand-trigger]') : null;
    if (!trigger) return;

    const menuEl = closestMegaMenu(trigger);
    if (!menuEl) return;

    const idx = parseInt(trigger.getAttribute('data-brand-index') || '0', 10);
    activateBrand(menuEl, idx);
  });
})();
(function () {
  function initBsLineInfoTeasers(root) {
    var scope = root || document;

    var sections = scope.querySelectorAll('.shopify-section--bs-line-info-teasers');
    if (!sections.length) return;

    sections.forEach(function (sectionEl) {
      // verhindert doppelte Listener (Theme Editor / Section reload)
      if (sectionEl.__bsLitInit) return;
      sectionEl.__bsLitInit = true;

      var track = sectionEl.querySelector('[data-bs-lit-track]');
      var bar = sectionEl.querySelector('[data-bs-lit-progressbar]');
      if (!track || !bar) return;

      function update() {
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 0) {
          bar.style.transform = 'scaleX(1)';
          return;
        }
        var p = track.scrollLeft / max;
        var min = 0.12;
        bar.style.transform = 'scaleX(' + (min + (1 - min) * p).toFixed(4) + ')';
      }

      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  // Initial
  document.addEventListener('DOMContentLoaded', function () {
    initBsLineInfoTeasers(document);
  });

  // Shopify Theme Editor: Section reloads
  document.addEventListener('shopify:section:load', function (event) {
    initBsLineInfoTeasers(event.target);
  });

  // Optional: wenn Blocks live editiert werden
  document.addEventListener('shopify:block:select', function (event) {
    initBsLineInfoTeasers(event.target.closest('.shopify-section') || document);
  });
})();
/* =========================================================
   BS: Linien-Info + Teaser – Progressbar Sync (Mobile)
   ========================================================= */
(function () {
  function initOne(root) {
    if (!root || root.__bsLitInit) return;
    root.__bsLitInit = true;

    var track = root.querySelector(".bs-lit__track");
    var bar = root.querySelector(".bs-lit__progressbar");
    if (!track || !bar) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) {
        bar.style.transform = "scaleX(1)";
        return;
      }
      var p = track.scrollLeft / max;
      var min = 0.12;
      bar.style.transform = "scaleX(" + (min + (1 - min) * p).toFixed(4) + ")";
    }

    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(".shopify-section--bs-line-info-teasers").forEach(initOne);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });

  /* Shopify Theme Editor: wenn Section neu geladen wird */
  document.addEventListener("shopify:section:load", function (e) {
    initAll(e.target);
  });
})();
/* =========================================================
   BS: Promo Product Popup
   1x pro 24h pro Produkt
   ========================================================= */

(function () {
  function initBsPromoPopup(scope) {
    var popups = (scope || document).querySelectorAll('[data-bs-promo-popup]');

    popups.forEach(function (popup) {
      if (popup.dataset.bsPromoPopupInitialized === 'true') return;
      popup.dataset.bsPromoPopupInitialized = 'true';

      var overlay = popup.querySelector('.bs-promo-popup__overlay');
      var dialog = popup.querySelector('.bs-promo-popup__dialog');
      var closeBtn = popup.querySelector('[data-bs-promo-popup-close]');
      var slidesEl = popup.querySelector('[data-bs-promo-popup-slides]');
      var slides = popup.querySelectorAll('.bs-promo-popup__slide');
      var dots = popup.querySelectorAll('.bs-promo-popup__dot');

      if (!overlay || !dialog || !slidesEl || !slides.length) return;

      if (!overlay.dataset.bsPromoPopupMoved) {
        document.body.appendChild(overlay);
        overlay.dataset.bsPromoPopupMoved = 'true';
      }

      var delay = parseInt(popup.getAttribute('data-delay'), 10);
      if (isNaN(delay)) delay = 1500;

      var oncePerSession = popup.getAttribute('data-once-per-session') === 'true';
      var sessionKey = popup.getAttribute('data-session-key') || '';
      var expiresAfter = 24 * 60 * 60 * 1000; // 24h

      var currentIndex = 0;
      var lastFocusedElement = null;
      var autoPlayInterval = null;
      var autoPlayDelay = 4500;

      function hasRecentlySeenPopup() {
        if (!oncePerSession || !sessionKey) return false;

        try {
          var stored = localStorage.getItem(sessionKey);
          if (!stored) return false;

          var lastShown = parseInt(stored, 10);
          if (isNaN(lastShown)) return false;

          return Date.now() - lastShown < expiresAfter;
        } catch (e) {
          return false;
        }
      }

      function markPopupAsSeen() {
        if (!oncePerSession || !sessionKey) return;

        try {
          localStorage.setItem(sessionKey, String(Date.now()));
        } catch (e) {}
      }

      if (hasRecentlySeenPopup()) return;

      function setupFadeSlider() {
        if (slides.length <= 1) return;

        slidesEl.style.position = 'relative';
        slidesEl.style.display = 'block';

        slides.forEach(function (slide, index) {
          slide.style.position = index === 0 ? 'relative' : 'absolute';
          slide.style.inset = '0';
          slide.style.transition = 'opacity 0.45s ease';
          slide.style.opacity = index === 0 ? '1' : '0';
          slide.style.pointerEvents = index === 0 ? 'auto' : 'none';
        });
      }

      function updateSlider(index) {
        currentIndex = index;

        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === currentIndex;
          slide.style.opacity = isActive ? '1' : '0';
          slide.style.pointerEvents = isActive ? 'auto' : 'none';
          slide.style.position = isActive ? 'relative' : 'absolute';
          slide.style.inset = '0';
        });

        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === currentIndex);
        });
      }

      function stopAutoPlay() {
        if (autoPlayInterval) {
          clearInterval(autoPlayInterval);
          autoPlayInterval = null;
        }
      }

      function startAutoPlay() {
        if (slides.length <= 1) return;

        stopAutoPlay();

        autoPlayInterval = setInterval(function () {
          var next = currentIndex + 1;
          if (next >= slides.length) next = 0;
          updateSlider(next);
        }, autoPlayDelay);
      }

      function openPopup() {
        overlay.hidden = false;
        document.body.classList.add('bs-promo-popup-open');
        lastFocusedElement = document.activeElement;

        markPopupAsSeen();

        window.setTimeout(function () {
          if (closeBtn) closeBtn.focus();
        }, 30);

        startAutoPlay();
      }

      function closePopup() {
        overlay.hidden = true;
        document.body.classList.remove('bs-promo-popup-open');
        stopAutoPlay();

        if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
          lastFocusedElement.focus();
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var nextIndex = parseInt(dot.getAttribute('data-index'), 10);
          if (isNaN(nextIndex)) return;

          updateSlider(nextIndex);
          startAutoPlay();
        });
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', closePopup);
      }

      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) {
          closePopup();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (overlay.hidden) return;

        if (event.key === 'Escape') {
          closePopup();
        }
      });

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoPlay();
        } else if (!overlay.hidden) {
          startAutoPlay();
        }
      });

      setupFadeSlider();
      updateSlider(0);

      window.setTimeout(function () {
        openPopup();
      }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initBsPromoPopup(document);
    });
  } else {
    initBsPromoPopup(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBsPromoPopup(event.target);
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    initBsPromoPopup(event.target);
  });
})();
/* =========================================================
   BS: Cart Drawer Line Item Ajax Fallback
   - fängt + / - / Entfernen im Cart Drawer zuverlässig ab
   - hält den Drawer offen
   ========================================================= */

(function () {
  if (window.__bsCartDrawerAjaxFallbackInit) return;
  window.__bsCartDrawerAjaxFallbackInit = true;

  function parseTargetFromUrl(urlString) {
    try {
      var url = new URL(urlString, window.location.origin);
      var quantity = parseInt(url.searchParams.get('quantity'), 10);
      var id = url.searchParams.get('id');
      var line = url.searchParams.get('line');

      if (isNaN(quantity)) quantity = 0;

      return {
        id: id,
        line: line,
        quantity: quantity
      };
    } catch (e) {
      return null;
    }
  }

  async function changeCartLine(payload) {
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    var sectionsToBundle = new Set();
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle }
      })
    );

    var body = {
      quantity: payload.quantity,
      sections: Array.from(sectionsToBundle).join(',')
    };

    if (payload.id) {
      body.id = payload.id;
    } else if (payload.line) {
      body.line = parseInt(payload.line, 10);
    } else {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      return;
    }

    var response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

    if (!response.ok) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return;
    }

    var cartContent = await response.json();

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'line-item:change',
          cart: cartContent
        }
      })
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest(
        'cart-drawer line-item a[href*="/cart/change"], cart-drawer .line-item__remove-button[href]'
      );

      if (!link) return;

      event.preventDefault();
      event.stopPropagation();

      var parsed = parseTargetFromUrl(link.href);
      if (!parsed) return;

      changeCartLine(parsed);
    },
    true
  );

  document.addEventListener(
    'change',
    function (event) {
      var input = event.target.closest('cart-drawer line-item input[data-line-key]');
      if (!input) return;

      var qty = parseInt(input.value, 10);
      if (isNaN(qty)) return;

      changeCartLine({
        id: input.getAttribute('data-line-key'),
        quantity: qty
      });
    },
    true
  );
})();
